export const htmlFollow = async (row, user, param) => {
    var today = row.getValue('date')
    var sToday = today.split('/')
    console.log(sToday)  
    var month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][Number(sToday[1])-1];
    var sDate = 'Curitiba, ' + Number(sToday[0]) + ' de ' + month + ' de ' + sToday[2] + '.'
    //console.log('foi 1')
    //console.log(user)
    //console.log(param)
  //  var sNota = ''
    //if (nota < 10) sNota = '00' + nota
    //else if (nota < 100) sNota = '0' + nota
    //else sNota = nota
    let html =
        '<html> ' +
        '<head> ' +
        '<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" /> ' +
        '</head> ' +
        '<body> ' +
        '<Image src="https://storage.googleapis.com/ticoop-br.appspot.com/crdd.png" ' +
                'style="position: absolute; left: 0px; top: 0px; width: 230; height: 230; z-index: -1;" ' +
            '/> ' +
            '<div style="font-size: 30; margin-left: 300;  margin-top: 120; width: 150;  ">CERTIDÃO</div> ' +
            '<div style="font-size: 15; margin-left: 50;  margin-top: 50; width: 600; ">&emsp;&emsp;Certificamos para os devidos fins e efeitos, nos termos do Inciso III do Art. 5° e do Art. 12° da Lei Federal N° 14.282 de 2021 que o(a) PROFISSIONAL DESPACHANTE DOCUMENTALISTA de Veículos Terrestres abaixo qualificado, encontra-se devidamente inscrito e em situação regular perante o Conselho Regional dos Despachantes Documentalistas do estado do Paraná - CRDD-PR.:</div> ' +
 
            '<div style="font-size: 18; border-style: groove; margin-left: 50;  margin-top: 50; width: 600; height: 28; text-align: center; ">' + user.name + '</div> ' +
            '<div style="font-size: 18; border-style: groove; margin-left: 50;  width: 600; height: 25; text-align: center; ">Filiação CRDD-PR n°' + user.crdd + ' - RG: ' + user.docaux + ' - CPF: ' + user.document + '</div> ' +
            '<div style="font-size: 18; border-style: groove; margin-left: 50;  width: 600; height: 25; text-align: center; ">Portaria Detran ' + user.ordinance + ' - Matrícula Detran ' + user.registration + '</div>' + 
            '<div style="font-size: 18; border-style: groove; margin-left: 50;  width: 600; height: 25; text-align: center; ">Município de ' + user.city + '-PR</div> ' +

            '<div style="font-size: 15; margin-left: 50;  margin-top: 50; width: 600;  ">A presente certidão tem validade de 06 meses.</div> ' +
            '<div style="font-size: 15; margin-left: 50;  margin-top: 40; width: 600;  ">' + sDate + '</div> ' +

            

            '<div style="display: flex; margin-top:50px">' +
            '<div style="width:50%; float:left; text-align:center;">'+
            '<Image src="https://storage.googleapis.com/ticoop-br.appspot.com/assinatura01.png" ' +
                'style="margin-top: 15;"' +
            //    'style="position: absolute; left: 120px; top: 770px; z-index: -1;" ' +
            '/> ' +
            '<br>' + param.president+'<br>Presidente</div>' +
            '<div style="width:50%; float:left; text-align:center;">' +
            '<Image src="https://storage.googleapis.com/ticoop-br.appspot.com/assinatura02.png" ' +
            //    'style="position: absolute; left: 450px; top: 750px; z-index: -1;" ' +
            '/> ' +
            '<br>' + param.director+'<br>Diretor de Cadastro e Reg. Profissional</div>' +
            '</div>' +

            '<div id="qrcode" style="margin-left: 300; margin-top: 50"></div>' + 

            '<div style="font-size: 10; margin-left: 300">Escaneie o QRCODE para <br>verificar a autenticidade</div>' +

            '<div style="font-size: 13; margin-left: 50;  margin-top: 60; width: 600; text-align: center; ">' + param.name + '</div> ' +
            '<div style="font-size: 13; margin-left: 50;  width: 600; text-align: center; ">' + param.address + '</div> ' +
            '<div style="font-size: 13; margin-left: 50;  width: 600; text-align: center; ">Email: ' + param.email + ' Site: ' + param.site + '</div> ' +
            '<div style="font-size: 13; margin-left: 50;  width: 600; text-align: center; ">Fone: ' + param.phone + '</div> ' 

/*            '<div style="break-after:page"></div> ' +

            '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p2-3.png" ' +
                'style="margin-left: -10; width: 870; height: 1120; z-index: -1;" ' +
            '/> ' + 
            '<div style="font-size: 55; margin-left: 280;  margin-top: -980; width: 550;  font-weight: bold;">O Desenvolver</div> ' +
            '<div style="font-size: 18; margin-left: 270;  margin-top: 10; width: 550; ">Este material foi gerado pelo aplicativo Desenvolver. O Desenvolver é uma ferramenta que simplifica o acompanhamento do crescimento das crianças e apoia o desenvolvimento saudável delas.</div> '+
            '<div style="font-size: 18; margin-left: 270;  margin-top: 5; width: 550;">A sequência do desenvolvimento infantil é razoavelmente fixa, mas existe um ritmo individual para cada criança, que depende de vários fatores biológicos, inclusive genéticos, do ambiente, do contexto em que a criança está inserida e da cultura.</div> ' +
            '<div style="font-size: 18; margin-left: 270;  margin-top: 5; width: 550; ">Algumas crianças podem apresentar um ritmo de desenvolvimento um pouco mais lento, não significando anormalidade e sim um sinal de alerta.</div> ' +
            '<div style="font-size: 18; margin-left: 270;  margin-top: 5; width: 550; ">Este Guia, tão útil quão importante, é resultado da experiência sedimentada e complementada do pediatra, Professor Dr. Jayme Murahovschi e da psicóloga especialista em terapia familiar, Jadete Calixto. Ele pode ser utilizado por pais, profissionais da saúde e da educação.</div> ' +
            '<div style="break-after:page"></div> ' +

            '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p2-3.png" ' +
                'style="margin-left: -10; width: 870; height: 1120; z-index: -1;" ' +
            '/> ' +
            '<div style="font-size: 35; margin-left: 410;  margin-top: -980; width: 150;  ">BIOPSICOSOCIAL</div> ' +
            '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/grafico' +
            sNota +
            '.png" style="margin-left: 340; width: 400;margin-top: 10"/> ' + 
            '<div style="font-size: 65; margin-left: 250;  margin-top: 10; width: 150; font-weight: bold; ">Sobre</div> ' +
            '<div style="font-size: 18; margin-left: 270;  margin-top: 10; width: 550; ">Não é preciso resultado de 100% de respostas positivas para que a criança seja considerada dentro dos padrões de desenvolvimento, porém, consulte o pediatra caso apresente respostas negativas. Ele avaliará com maior precisão cada aspecto e fará os encaminhamentos necessários.</div>' +
            '<div style="font-size: 18; margin-left: 270;  margin-top: 5; width: 550; ">Independente das respostas, é necessário levar a criança ao pediatra periodicamente.</div>' +
            '<div style="font-size: 30; margin-left: 270;  margin-top: 50; width: 150; font-weight: bold; ">Observações</div>' +
            '<div style="font-size: 18; margin-left: 270;  margin-top: 10; width: 450; ">' +
            anotacoes +
            '</div>' +
            '<div style="break-after:page"></div> ' +

            '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
            '/> ' +
            '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
        for (var i=0; i<10; i++){
            if (i < questoes.length){
                html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                    (i+1) + ' - ' + questoes[i].pergunta +
                    '</div> ' +
                    '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                    respostas[i] + 
                    '</div> '
            }
        }
        html += '<div style="break-after:page"></div> '
        if (questoes.length > 10){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=10; i<20; i++){
                if (i < questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
        }
        html += '<div style="break-after:page"></div> '
        if (questoes.length > 20){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=20; i<30; i++){
                if (i < questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 30){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=30; i<40; i++){
                if (i < questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }

        if (questoes.length > 40){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=40; i<50; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 50){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=50; i<60; i++){
                if (i < questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 60){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=60; i<70; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 70){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=70; i<80; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 80){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=80; i<90; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }
        if (questoes.length > 90){
            html += '<Image src="https://storage.googleapis.com/api-desenvolver.appspot.com/Fundo_p1.png" ' +
                'style="margin-left: -10; width: 250; height: 1120; z-index: -1;" ' +
                '/> ' +
                '<div style="font-size: 55; margin-left: 250;  margin-top: -1050; width: 150; font-weight: bold;margin-bottom: 30 ">Respostas</div>'
            for (var i=90; i<100; i++){
                if (i <= questoes.length){
                    html += '<div style="font-size: 18; margin-left: 300;  margin-top: 10; width: 450; ">' +
                        (i+1) + ' - ' + questoes[i].pergunta +
                        '</div> ' +
                        '<div style="font-size: 18; margin-left: 330;  margin-top: 10; width: 450; ">' +
                        respostas[i] + 
                        '</div> '
                }
            }
            html += '<div style="break-after:page"></div> '
        }*/
        html += '<script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>' +
            '<script>' +
            'new QRCode(document.getElementById("qrcode"), {text: "https://api-dot-crdd-api.rj.r.appspot.com/api/certificate/validate/'+ row.getValue('_id') + '", width: 120, height: 120, colorDark: "#000000", colorLight: "#ffffff",});' +
            '</script>' 

        html += '</body> ' +
            '</html>'
    return html;
}

